import { render, staticRenderFns } from "./DeleteAccount.vue?vue&type=template&id=270f81b5&scoped=true"
import script from "./DeleteAccount.vue?vue&type=script&lang=js"
export * from "./DeleteAccount.vue?vue&type=script&lang=js"
import style0 from "./DeleteAccount.vue?vue&type=style&index=0&id=270f81b5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270f81b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('270f81b5')) {
      api.createRecord('270f81b5', component.options)
    } else {
      api.reload('270f81b5', component.options)
    }
    module.hot.accept("./DeleteAccount.vue?vue&type=template&id=270f81b5&scoped=true", function () {
      api.rerender('270f81b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EmailAccounts/DeleteAccount.vue"
export default component.exports